export default __webpack_public_path__ + "static/media/576.4c83544e.png";